import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { GetOrganisationId } from 'nallian-shared-ui/lib/selectors';
import createVehicleService from '../services/createVehicleService';
import VehicleFormModal from './VehicleFormModal';

const NewVehicleModal = ({
  open,
  createVehicleFetch,
  dispatchCreateVehiclePost,
  t,
  organisationId,
}) => {
  if (!open) {
    return null;
  }
  return (
    <VehicleFormModal
      header={t('newVehicle')}
      onSubmit={dispatchCreateVehiclePost}
      submitProcessing={!!createVehicleFetch.pending}
      data={{ owner: { ownedById: organisationId } }}
      returnRoute="/vehicles"
    />
  );
};

NewVehicleModal.propTypes = {
  t: PropTypes.func.isRequired,
  dispatchCreateVehiclePost: PropTypes.func.isRequired,
  createVehicleFetch: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  organisationId: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  organisationId: GetOrganisationId(state),
});

export default compose(
  connect(mapStateToProps),
  withTranslation(),
  createVehicleService
)(NewVehicleModal);
